"use client";

import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QuickReservationCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="quick-reservation-calltoaction" ref={ref} className="dark bg-background text-foreground relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(/img/los_angeles_luxury_night_bokeh.png)]" style={{
      filter: "blur(2px)"
    }} />
      
      {}
      <div className="surface-overlay" />

      {}
      <div className={`relative z-10 text-center px-4 py-16 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <Link to="tel:323-492-6292" className="inline-block group focus-ring">
          <div className="flex items-center justify-center gap-4 mb-8 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105">
            <Phone className="size-12 md:size-16 text-secondary-dark" />
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold tracking-tight text-white">
              323-492-6292
            </h1>
          </div>
        </Link>

        <div className="flex justify-center mb-8">
          <img src="https://humane-alien.10web.cloud/wp-content/uploads/2026/02/Untitled-scaled.jpg" alt="New cars with clients" className="max-w-full h-auto rounded-lg shadow-strong max-h-[300px] object-cover" />
        </div>

        {}
        <div className="mb-8">
          <Button asChild className="border-2 border-white text-white bg-transparent px-8 py-6 text-lg font-semibold uppercase tracking-wider rounded-md hover:bg-white/20 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus-ring">
            <Link to="tel:323-492-6292">
              Call or Text Now
            </Link>
          </Button>
        </div>

        {}
        <div className="flex items-center justify-center gap-2">
          <span className="relative flex size-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75" />
            <span className="relative inline-flex rounded-full size-3 bg-secondary" />
          </span>
          <p className="text-sm md:text-base text-white/90 font-medium uppercase tracking-wide">
            Available 24/7
          </p>
        </div>
      </div>
    </section>;
}